// extracted by mini-css-extract-plugin
export default {"root":"HywkRX6O","element":"_1jR43naJ"};